var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "v-container",
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", md10: "", "offset-md1": "" } },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "p-10",
                          staticStyle: { margin: "130px 0 !important" }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs0: "", sm7: "", md8: "" } },
                                [
                                  _c(
                                    "v-card",
                                    {
                                      staticClass:
                                        "overflow-hidden text-xs-center elc-login-card"
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src:
                                            "/static/assets/image/elc_background.png"
                                        }
                                      })
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm5: "", md4: "" } },
                                [
                                  _vm.loginFlag
                                    ? _c(
                                        "v-card",
                                        { staticClass: "elc-login-card1" },
                                        [
                                          _c(
                                            "v-card-text",
                                            [
                                              _c(
                                                "h1",
                                                {
                                                  staticClass: "text-xs-center",
                                                  staticStyle: {
                                                    color: "#515a75"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            ELC Arvalli\n                                        "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-form",
                                                { ref: "form" },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass: "p-t-20",
                                                    attrs: {
                                                      "prepend-icon": "phone",
                                                      label: "Mobile",
                                                      mask: _vm.mask,
                                                      rules: _vm.phoneRules
                                                    },
                                                    on: {
                                                      keyup: function($event) {
                                                        if (
                                                          !(
                                                            "button" in $event
                                                          ) &&
                                                          _vm._k(
                                                            $event.keyCode,
                                                            "enter",
                                                            13,
                                                            $event.key,
                                                            "Enter"
                                                          )
                                                        ) {
                                                          return null
                                                        }
                                                        return _vm.checkEnter(
                                                          $event
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value: _vm.phone,
                                                      callback: function($$v) {
                                                        _vm.phone = $$v
                                                      },
                                                      expression: "phone"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("v-text-field", {
                                                    staticClass: "p-t-20",
                                                    attrs: {
                                                      "prepend-icon": "lock",
                                                      label: "Password",
                                                      id: "password",
                                                      type: "password",
                                                      rules: _vm.passwordRules
                                                    },
                                                    on: {
                                                      keyup: function($event) {
                                                        if (
                                                          !(
                                                            "button" in $event
                                                          ) &&
                                                          _vm._k(
                                                            $event.keyCode,
                                                            "enter",
                                                            13,
                                                            $event.key,
                                                            "Enter"
                                                          )
                                                        ) {
                                                          return null
                                                        }
                                                        return _vm.checkEnter(
                                                          $event
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value: _vm.password,
                                                      callback: function($$v) {
                                                        _vm.password = $$v
                                                      },
                                                      expression: "password"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("v-spacer"),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-card-actions",
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticClass:
                                                            "elc-button-radius-color m-t-20 m-b-20",
                                                          attrs: {
                                                            large: "",
                                                            block: ""
                                                          },
                                                          on: {
                                                            click: _vm.submit
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Login\n                                                "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("div", [
                                                _c(
                                                  "p",
                                                  { staticClass: "elc-pwd" },
                                                  [
                                                    _vm._v(
                                                      "Forgot password ? "
                                                    ),
                                                    _c(
                                                      "a",
                                                      {
                                                        on: {
                                                          click: _vm.forgotPwd
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "click\n                                                here"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _vm.error.length > 0
                                                ? _c("div", [
                                                    _c(
                                                      "ul",
                                                      {
                                                        staticStyle: {
                                                          color: "red"
                                                        }
                                                      },
                                                      _vm._l(
                                                        _vm.error,
                                                        function(message) {
                                                          return _c("li", [
                                                            _vm._v(
                                                              _vm._s(message)
                                                            )
                                                          ])
                                                        }
                                                      )
                                                    )
                                                  ])
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.fpFlag
                                    ? _c(
                                        "v-card",
                                        { staticClass: "elc-login-card1" },
                                        [
                                          _c("v-card-text", [
                                            _c(
                                              "h1",
                                              {
                                                staticClass: "text-xs-center",
                                                staticStyle: {
                                                  color: "#515a75"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            Forgot Password ?\n                                        "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "v-form" },
                                              [
                                                _c("v-text-field", {
                                                  ref: "formFP",
                                                  staticClass: "p-t-20 ",
                                                  attrs: {
                                                    "prepend-icon": "phone",
                                                    label: "Phone",
                                                    mask: _vm.mask,
                                                    rules: _vm.phoneRules
                                                  },
                                                  on: {
                                                    keyup: function($event) {
                                                      if (
                                                        !("button" in $event) &&
                                                        _vm._k(
                                                          $event.keyCode,
                                                          "enter",
                                                          13,
                                                          $event.key,
                                                          "Enter"
                                                        )
                                                      ) {
                                                        return null
                                                      }
                                                      return _vm.generateOTP(
                                                        $event
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: _vm.rpPhone,
                                                    callback: function($$v) {
                                                      _vm.rpPhone = $$v
                                                    },
                                                    expression: "rpPhone"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("v-spacer"),
                                                _vm._v(" "),
                                                _c(
                                                  "v-card-actions",
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        staticClass:
                                                          "elc-button-radius-color m-t-20 m-b-20",
                                                        attrs: {
                                                          large: "",
                                                          block: ""
                                                        },
                                                        on: {
                                                          click: _vm.generateOTP
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Submit\n                                                "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("div", [
                                              _c(
                                                "p",
                                                { staticClass: "elc-pwd" },
                                                [
                                                  _vm._v("Sign in"),
                                                  _c(
                                                    "a",
                                                    {
                                                      on: {
                                                        click:
                                                          _vm.afterResetLoginFP
                                                      }
                                                    },
                                                    [_vm._v(" Here ")]
                                                  )
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _vm.error.length > 0
                                              ? _c("div", [
                                                  _c(
                                                    "ul",
                                                    {
                                                      staticStyle: {
                                                        color: "red"
                                                      }
                                                    },
                                                    _vm._l(_vm.error, function(
                                                      message
                                                    ) {
                                                      return _c("li", [
                                                        _vm._v(_vm._s(message))
                                                      ])
                                                    })
                                                  )
                                                ])
                                              : _vm._e()
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.vOTPFlag
                                    ? _c(
                                        "v-card",
                                        { staticClass: "elc-login-card1" },
                                        [
                                          _c("v-card-text", [
                                            _c(
                                              "h1",
                                              {
                                                staticClass: "text-xs-center",
                                                staticStyle: {
                                                  color: "#515a75"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            Enter OTP\n                                        "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "v-form" },
                                              [
                                                _c("v-text-field", {
                                                  ref: "otp",
                                                  staticClass: "p-t-20",
                                                  attrs: {
                                                    label: "OTP",
                                                    rules: _vm.fieldRules
                                                  },
                                                  on: {
                                                    keyup: function($event) {
                                                      if (
                                                        !("button" in $event) &&
                                                        _vm._k(
                                                          $event.keyCode,
                                                          "enter",
                                                          13,
                                                          $event.key,
                                                          "Enter"
                                                        )
                                                      ) {
                                                        return null
                                                      }
                                                      return _vm.verifyOTP(
                                                        $event
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: _vm.otp,
                                                    callback: function($$v) {
                                                      _vm.otp = $$v
                                                    },
                                                    expression: "otp"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("v-spacer"),
                                                _vm._v(" "),
                                                _c(
                                                  "v-card-actions",
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        staticClass:
                                                          "elc-button-radius-color m-t-20 m-b-20",
                                                        attrs: {
                                                          large: "",
                                                          block: ""
                                                        },
                                                        on: {
                                                          click: _vm.verifyOTP
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Submit\n                                                "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("div", [
                                              _c(
                                                "p",
                                                { staticClass: "elc-pwd" },
                                                [
                                                  _vm._v("Sign in"),
                                                  _c(
                                                    "a",
                                                    {
                                                      on: {
                                                        click:
                                                          _vm.afterResetLoginVOTP
                                                      }
                                                    },
                                                    [_vm._v(" Here ")]
                                                  )
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _vm.error.length > 0
                                              ? _c("div", [
                                                  _c(
                                                    "ul",
                                                    {
                                                      staticStyle: {
                                                        color: "red"
                                                      }
                                                    },
                                                    _vm._l(_vm.error, function(
                                                      message
                                                    ) {
                                                      return _c("li", [
                                                        _vm._v(_vm._s(message))
                                                      ])
                                                    })
                                                  )
                                                ])
                                              : _vm._e()
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.rpFlag
                                    ? _c(
                                        "v-card",
                                        { staticClass: "elc-login-card1" },
                                        [
                                          _c("v-card-text", [
                                            _c(
                                              "h1",
                                              {
                                                staticClass: "text-xs-center",
                                                staticStyle: {
                                                  color: "#515a75"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            Reset Password\n                                        "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "v-form" },
                                              [
                                                _c("v-text-field", {
                                                  ref: "formRPPassword",
                                                  staticClass:
                                                    "p-t-20 rp_key_enter",
                                                  attrs: {
                                                    "prepend-icon": "lock",
                                                    label: "New Password",
                                                    id: "rpPassword",
                                                    type: "password",
                                                    rules: _vm.passwordRules
                                                  },
                                                  on: {
                                                    keyup: function($event) {
                                                      if (
                                                        !("button" in $event) &&
                                                        _vm._k(
                                                          $event.keyCode,
                                                          "enter",
                                                          13,
                                                          $event.key,
                                                          "Enter"
                                                        )
                                                      ) {
                                                        return null
                                                      }
                                                      return _vm.resetNewPassword(
                                                        $event
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: _vm.rpPassword,
                                                    callback: function($$v) {
                                                      _vm.rpPassword = $$v
                                                    },
                                                    expression: "rpPassword"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("v-text-field", {
                                                  ref: "formRPConfirmPassword",
                                                  staticClass:
                                                    "p-t-20 rp_key_enter",
                                                  attrs: {
                                                    "prepend-icon": "lock",
                                                    label: "Confirm Password",
                                                    id: "rpConfirmPassword",
                                                    type: "password",
                                                    rules: _vm.passwordRules
                                                  },
                                                  on: {
                                                    keyup: function($event) {
                                                      if (
                                                        !("button" in $event) &&
                                                        _vm._k(
                                                          $event.keyCode,
                                                          "enter",
                                                          13,
                                                          $event.key,
                                                          "Enter"
                                                        )
                                                      ) {
                                                        return null
                                                      }
                                                      return _vm.resetNewPassword(
                                                        $event
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.rpConfirmPassword,
                                                    callback: function($$v) {
                                                      _vm.rpConfirmPassword = $$v
                                                    },
                                                    expression:
                                                      "rpConfirmPassword"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("v-spacer"),
                                                _vm._v(" "),
                                                _c(
                                                  "v-card-actions",
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        staticClass:
                                                          "elc-button-radius-color m-t-20 m-b-20",
                                                        attrs: {
                                                          large: "",
                                                          block: ""
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.resetNewPassword
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                    Submit\n                                                "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("div", [
                                              _c(
                                                "p",
                                                { staticClass: "elc-pwd" },
                                                [
                                                  _vm._v("Sign in"),
                                                  _c(
                                                    "a",
                                                    {
                                                      on: {
                                                        click:
                                                          _vm.afterResetLoginRP
                                                      }
                                                    },
                                                    [_vm._v(" Here")]
                                                  )
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _vm.error.length > 0
                                              ? _c("div", [
                                                  _c(
                                                    "ul",
                                                    {
                                                      staticStyle: {
                                                        color: "red"
                                                      }
                                                    },
                                                    _vm._l(_vm.error, function(
                                                      message
                                                    ) {
                                                      return _c("li", [
                                                        _vm._v(_vm._s(message))
                                                      ])
                                                    })
                                                  )
                                                ])
                                              : _vm._e()
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "elc-login" }, [
      _c("img", {
        attrs: { src: "/static/assets/image/login_back_ground.png" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-657094ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-657094ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/Login.vue
// module id = null
// module chunks = 